<template>
    <div>
        <heading :text="fields.address_heading"></heading>
        <p v-for="(item, index) in fields.address_lines"
            :key="index" v-text="item.line"></p>
    </div>
</template>

<script>
import { Heading } from '@freddiesflowers/frontend-component-library';

export default {
    name: 'trt-address',
    props: {
        fields: {
            type: Object,
        },
    },
    components: {
        Heading,
    },
};
</script>
